import React from "react";
// import Aboutvalue from "../components/Aboutus/Aboutvalue";
import Banner from '../comman/Banner/Banner';
import Ourvisionabout from "../components/Aboutus/Ourvision";


const Aboutvalueowner = () => {
  return (
    <>
      <Banner
        index={'about-2'}
      />
      <Ourvisionabout />
      {/* <Aboutvalue /> */}

    </>

  )
};

export default Aboutvalueowner;